import React from 'react';
import styled, { css } from 'styled-components';
import { compose } from 'styled-system';
import { IconWithText } from '../shared/IconWithText';
import { buttonVariants, stylesBySize, useAction } from '../shared';
import { addSuperscript } from '../../tools/utils/addSuperscript';
const composedStyledSystemProps = compose(buttonVariants);
const linkStyles = css(props => {
    const { $variant: variant, $isUnderlined, $width } = props;
    return css `
    ${() => composedStyledSystemProps({ variant })}
    ${$isUnderlined ? 'text-decoration: underline;' : ''}
    ${variant === 'link'
        ? `white-space: normal; 
          display: inline;`
        : ''}
    ${variant !== 'link' && props.$size ? stylesBySize[props.$size] : css ``};
    box-sizing: border-box;
    width: ${$width};
  `;
});
const StyledAnchor = styled.a `
  ${linkStyles}
`;
const Wrapper = styled.div `
  display: inline;

  a {
    ${linkStyles}
  }
`;
const Link = React.forwardRef((props, ref) => {
    const { icon, disableFullWidthSmDown = false, fullWidthMd } = props;
    const { derivedSize, width, iconFill, theme, safeVariant } = useAction('button', disableFullWidthSmDown, fullWidthMd, props.variant, 'size' in props ? props.size : undefined);
    const anchorProps = props.href && !props.children
        ? {
            id: props.id,
            className: props.className,
            onClick: props.onClick,
            target: props.target,
            tabIndex: props.tabIndex,
            download: props.download,
            href: props.href,
        }
        : undefined;
    // Casting to Routing props to fix typescript union issue
    const routingProps = {
        href: props.href,
        ref,
        children: props.children,
    };
    const iconWithText = (React.createElement(IconWithText, Object.assign({ icon: icon, iconFill: iconFill, theme: theme }, (safeVariant !== 'link' ? { size: derivedSize } : {})), addSuperscript(props.text) || props.unsupportedContent));
    const styleProps = {
        $isUnderlined: props.isUnderlined,
        $size: safeVariant !== 'link' ? derivedSize : undefined,
        $variant: safeVariant,
        $width: width,
    };
    return routingProps.children ? (React.createElement(Wrapper, Object.assign({}, styleProps, { className: props.className }), React.cloneElement(routingProps.children, {
        children: iconWithText,
        'data-allytmln': props.allytmln,
        'data-testid': props['data-testid'] || 'mui-link-router-anchor',
    }))) : (React.createElement(StyledAnchor, Object.assign({}, styleProps, anchorProps, { rel: "noreferrer noopener", ref: ref, "data-allytmln": props.allytmln, "data-testid": props['data-testid'] || 'mui-link-anchor' }), iconWithText));
});
Link.defaultProps = {
    variant: 'link',
};
export { Link };
//# sourceMappingURL=Link.js.map